// 定义公共状态
const state = {
  token: '',
  adminId: '',
  screenW: null,
  screenH: null,
  userName: '',
  userSubject: '',
  userSubjectId: ''
}

// 定义getter
const getters = {
  token: state => state.token,
  adminId: state => state.adminId,
  screenW: state => state.screenW,
  screenH: state => state.screenH,
  userNameGetter: state => state.userName,
  userSubjectGetter: state => state.userSubject,
  userSubjectIdGetter: state => state.userSubjectId
}

// 定义mutation
const mutations = {
  SET_TOKEN (state, token) {
    state.token = token
  },
  REMOVE_TOKEN (state) {
    state.token = ''
  },
  SET_ADMINID (state, id) {
    state.adminId = id
  },
  SET_SCREEN_PIXEL (state, data) {
    state.screenW = data.w
    state.screenH = data.h
  },
  SET_USER_NAME (state, data) {
    state.userName = data
  },
  SET_USER_SUBJECT (state, data) {
    state.userSubject = data
  },
  SET_USER_SUBJECT_ID (state, data) {
    state.userSubjectId = data
  }
}

// 定义actions
const actions = {
  getUserInfo: ({commit, state}) => {
    const info = localStorage.getItem('user_info')
    let result
    try {
      result = JSON.parse(info)
    } catch (e) {
      console.log(e)
    }
    if (result) {
      commit('SET_TOKEN', result.token || '')
      commit('SET_ADMINID', result.adminId || '')
      commit('SET_USER_NAME', result.userName || '')
      commit('SET_USER_SUBJECT', result.subjectName || '')
      commit('SET_USER_SUBJECT_ID', result.subjectId || '')
    }
  },
  removeToken: ({commit}) => commit('REMOVE_TOKEN'),
  setScreenPixel: ({commit}, data) => commit('SET_SCREEN_PIXEL', data)
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/common/index.js